import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["active", "value"],
  _excluded2 = ["active", "onClick", "children", "className"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { Children, cloneElement } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Button, { ButtonGroup } from '../Button';
import { jsx as _jsx } from "react/jsx-runtime";
var ButtonSwitch = function ButtonSwitch(_ref) {
  var _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    ghost = _ref.ghost,
    inverted = _ref.inverted,
    invisible = _ref.invisible,
    large = _ref.large,
    onClick = _ref.onClick,
    small = _ref.small,
    title = _ref.title,
    unfocusable = _ref.unfocusable,
    className = _ref.className,
    children = _ref.children;
  var onClickSelf = function onClickSelf(e, value) {
    if (!disabled) {
      if (onClick) {
        onClick(value, e);
      }
    }
  };
  var onBlur = function onBlur() {};
  var onKeyPress = function onKeyPress(e) {
    if (e.charCode === 32) {
      onClickSelf(e);
    } else if (e.charCode === 13) {
      onClickSelf(e);
    }
  };
  var restSwitchProps = {
    disabled: disabled,
    ghost: ghost,
    inverted: inverted,
    invisible: invisible,
    large: large,
    onClick: onClick,
    small: small,
    title: title,
    unfocusable: unfocusable,
    className: className
  };
  var content = Children.map(children, function (child) {
    var _child$props = child.props,
      active = _child$props.active,
      value = _child$props.value,
      props = _objectWithoutProperties(_child$props, _excluded);
    props = _objectSpread(_objectSpread(_objectSpread({}, restSwitchProps), props), {}, {
      active: active,
      //or state
      onClick: function onClick(evt) {
        return onClickSelf(evt, value);
      }
    });
    return /*#__PURE__*/cloneElement(child, props, child.props.children);
  });
  var classes = classNames('ptr-button-switch', {
    disabled: disabled,
    ghost: !!ghost,
    invisible: !!invisible,
    inverted: !!inverted,
    large: !!large,
    small: small
  }, className);
  return /*#__PURE__*/_jsx(ButtonGroup, {
    className: classes,
    onBlur: onBlur,
    onClick: onClickSelf,
    onKeyPress: onKeyPress,
    tabIndex: disabled || unfocusable ? '-1' : '0',
    title: title,
    children: content
  });
};
ButtonSwitch.propTypes = {
  disabled: PropTypes.bool,
  ghost: PropTypes.bool,
  inverted: PropTypes.bool,
  invisible: PropTypes.bool,
  large: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  small: PropTypes.bool,
  title: PropTypes.string,
  unfocusable: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node
};
export default ButtonSwitch;
export var ButtonSwitchOption = function ButtonSwitchOption(_ref2) {
  var active = _ref2.active,
    onClick = _ref2.onClick,
    children = _ref2.children,
    className = _ref2.className,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
    className: classNames(className, {
      active: active
    }),
    onClick: onClick
  }, props), {}, {
    children: children
  }));
};
ButtonSwitchOption.propTypes = {
  active: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  onClick: PropTypes.func
};